export default __webpack_public_path__ + "395b3c24818e37c843f483375e831ae6.png";